const ROUTER_LAYOUTS = Object.freeze({
  auth: 'auth',
  dashboard: 'dashboard',
});

export const ROUTES_NAMES = Object.freeze({
  dashboard: ROUTER_LAYOUTS.dashboard,
  home: `${ROUTER_LAYOUTS.dashboard}.home`,
  accounts: `${ROUTER_LAYOUTS.dashboard}.accounts`,
  account: `${ROUTER_LAYOUTS.dashboard}.account`,
  accountsVehicleDetails: `${ROUTER_LAYOUTS.dashboard}.accounts.vehicle-details`,
  accountIntegrationDetails: `${ROUTER_LAYOUTS.dashboard}.account-integration-details`,
  bankCallback: `${ROUTER_LAYOUTS.dashboard}.bank-callback`,
  planned: `${ROUTER_LAYOUTS.dashboard}.planned`,
  plannedSubscriptions: `${ROUTER_LAYOUTS.dashboard}.planned.subscriptions`,
  plannedSubscriptionDetails: `${ROUTER_LAYOUTS.dashboard}.planned.subscription-details`,
  plannedBudgets: `${ROUTER_LAYOUTS.dashboard}.planned.budgets`,
  plannedBudgetDetails: `${ROUTER_LAYOUTS.dashboard}.planned.budget-details`,
  budgets: `${ROUTER_LAYOUTS.dashboard}.budgets`,
  budgetsInfo: `${ROUTER_LAYOUTS.dashboard}.budgets.info`,
  subscriptions: `${ROUTER_LAYOUTS.dashboard}.subscriptions`,
  subscriptionDetails: `${ROUTER_LAYOUTS.dashboard}.subscription-details`,
  analytics: `${ROUTER_LAYOUTS.dashboard}.analytics`,
  analyticsCashFlow: `${ROUTER_LAYOUTS.dashboard}.analytics.cash-flow`,
  analyticsNetWorthHistory: `${ROUTER_LAYOUTS.dashboard}.analytics.net-worth-history`,
  analyticsFire: `${ROUTER_LAYOUTS.dashboard}.analytics.fire`,
  analyticsNetWorthDrivers: `${ROUTER_LAYOUTS.dashboard}.analytics.net-worth-drivers`,
  analyticsInvestmentContributions: `${ROUTER_LAYOUTS.dashboard}.analytics.investment-contributions`,
  analyticsPivotReport: `${ROUTER_LAYOUTS.dashboard}.analytics.pivot-report`,
  analyticsInvestmentCalculator: `${ROUTER_LAYOUTS.dashboard}.analytics.investment-calculator`,
  analyticsTrendsComparison: `${ROUTER_LAYOUTS.dashboard}.analytics.trends-comparison`,
  loans: `${ROUTER_LAYOUTS.dashboard}.loans`,
  loanDetail: `${ROUTER_LAYOUTS.dashboard}.loan-detail`,
  investments: `${ROUTER_LAYOUTS.dashboard}.investments`,
  investmentAccount: `${ROUTER_LAYOUTS.dashboard}.investment-account`,
  portfolioDetail: `${ROUTER_LAYOUTS.dashboard}.portfolio-detail`,
  portfolioTransactionsImport: `${ROUTER_LAYOUTS.dashboard}.portfolio-transactions-import`,
  venture: `${ROUTER_LAYOUTS.dashboard}.venture`,
  venturePlatformsList: `${ROUTER_LAYOUTS.dashboard}.venture.platforms`,
  ventureDealDetail: `${ROUTER_LAYOUTS.dashboard}.venture.deal-detail`,
  transactions: `${ROUTER_LAYOUTS.dashboard}.transactions`,
  transactionGroups: `${ROUTER_LAYOUTS.dashboard}.transaction-groups`,
  optimizations: `${ROUTER_LAYOUTS.dashboard}.optimizations`,
  optimizationsTransfers: `${ROUTER_LAYOUTS.dashboard}.optimizations.transfers`,
  optimizationsAiCategorization: `${ROUTER_LAYOUTS.dashboard}.optimizations.ai-categorization`,
  optimizationsReconciliation: `${ROUTER_LAYOUTS.dashboard}.optimizations.reconciliation`,
  automations: `${ROUTER_LAYOUTS.dashboard}.automations`,
  automationCreate: `${ROUTER_LAYOUTS.dashboard}.automations.create`,
  automationDetails: `${ROUTER_LAYOUTS.dashboard}.automations.details`,
  settings: `${ROUTER_LAYOUTS.dashboard}.settings`,
  settingsCurrencies: `${ROUTER_LAYOUTS.dashboard}.settings.currencies`,
  settingsCategories: `${ROUTER_LAYOUTS.dashboard}.settings.categories`,
  settingsTags: `${ROUTER_LAYOUTS.dashboard}.settings.tags`,
  settingsPayees: `${ROUTER_LAYOUTS.dashboard}.settings.payees`,
  settingsPayeesManage: `${ROUTER_LAYOUTS.dashboard}.settings.payees.manage`,
  settingsPayeesSettings: `${ROUTER_LAYOUTS.dashboard}.settings.payees.settings`,
  settingsPayeeDetail: `${ROUTER_LAYOUTS.dashboard}.settings.payee-detail`,
  settingsAccounts: `${ROUTER_LAYOUTS.dashboard}.settings.accounts-groups`,
  settingsDataManagement: `${ROUTER_LAYOUTS.dashboard}.settings.data-management`,
  settingsDataManagementImport: `${ROUTER_LAYOUTS.dashboard}.settings.data-management.import`,
  settingsDataManagementExport: `${ROUTER_LAYOUTS.dashboard}.settings.data-management.export`,
  settingsDataManagementExportConfigure: `${ROUTER_LAYOUTS.dashboard}.settings.data-management.export.configure`,
  settingsAppearance: `${ROUTER_LAYOUTS.dashboard}.settings.appearance`,
  settingsLanguage: `${ROUTER_LAYOUTS.dashboard}.settings.language`,
  settingsGeneral: `${ROUTER_LAYOUTS.dashboard}.settings.general`,
  settingsAi: `${ROUTER_LAYOUTS.dashboard}.settings.ai`,
  settingsAiFeatures: `${ROUTER_LAYOUTS.dashboard}.settings.ai.features`,
  settingsAiModels: `${ROUTER_LAYOUTS.dashboard}.settings.ai.models`,
  settingsAiConnectedApps: `${ROUTER_LAYOUTS.dashboard}.settings.ai.connected-apps`,
  settingsSecurity: `${ROUTER_LAYOUTS.dashboard}.settings.security`,
  settingsSecurityLoginMethods: `${ROUTER_LAYOUTS.dashboard}.settings.security.login-methods`,
  settingsSecuritySessions: `${ROUTER_LAYOUTS.dashboard}.settings.security.sessions`,
  settingsSecurityPassword: `${ROUTER_LAYOUTS.dashboard}.settings.security.password`,
  settingsSecurityBackup: `${ROUTER_LAYOUTS.dashboard}.settings.security.backup`,
  settingsSecurityDanger: `${ROUTER_LAYOUTS.dashboard}.settings.security.danger`,
  settingsAdmin: `${ROUTER_LAYOUTS.dashboard}.settings.admin`,
  settingsSharedWithMe: `${ROUTER_LAYOUTS.dashboard}.settings.shared-with-me`,
  settingsHousehold: `${ROUTER_LAYOUTS.dashboard}.settings.household`,
  settingsSubscriptions: `${ROUTER_LAYOUTS.dashboard}.settings.subscriptions`,
  settingsPlanBilling: `${ROUTER_LAYOUTS.dashboard}.settings.plan-billing`,
  importCsv: `${ROUTER_LAYOUTS.dashboard}.import-csv`,
  importStatement: `${ROUTER_LAYOUTS.dashboard}.import-statement`,
  importYnab: `${ROUTER_LAYOUTS.dashboard}.import-ynab`,
  importBudgetBakersWallet: `${ROUTER_LAYOUTS.dashboard}.import-budget-bakers-wallet`,
  importMsMoney: `${ROUTER_LAYOUTS.dashboard}.import-ms-money`,
  importOfx: `${ROUTER_LAYOUTS.dashboard}.import-ofx`,
  importHistory: `${ROUTER_LAYOUTS.dashboard}.import-history`,
  notFound: `${ROUTER_LAYOUTS.dashboard}.not-found`,

  auth: ROUTER_LAYOUTS.auth,
  signIn: `${ROUTER_LAYOUTS.auth}.sign-in`,
  signUp: `${ROUTER_LAYOUTS.auth}.sign-up`,
  verifyEmail: `${ROUTER_LAYOUTS.auth}.verify-email`,
  welcome: `${ROUTER_LAYOUTS.auth}.welcome`,
  authCallback: `${ROUTER_LAYOUTS.auth}.callback`,
  oauthAuthorize: `${ROUTER_LAYOUTS.auth}.oauth-authorize`,
});
